import React, { useState } from "react";
import chevronUpIcon from "../assets/chevron_up.svg";
import { TraceBlock } from "./Chat/Chat.types";
import { renderTraceBlock } from "./registry/traceRegistry";

export interface TraceStepItemProps {
	block: TraceBlock;
}

/**
 * One raw trace row — the verbose view. Rendering is delegated to the
 * trace registry; this component owns only the accordion shell.
 *
 * This is the pre-audit-timeline rendering, and it is now reached only when
 * the timeline flag is OFF. The timeline itself never renders it: a step
 * there is one semantic line with nothing to expand.
 */
const TraceStepItem: React.FC<TraceStepItemProps> = ({ block }) => {
	const [isOpen, setIsOpen] = useState(true);
	const data = renderTraceBlock(block);
	if (!data) return null;

	const { icon, header, body, stepClass } = data;
	const hasBody = body !== null;

	return (
		<div className={stepClass}>
			{icon}
			<div className="trace-step-content">
				<button
					className={`trace-step-header${hasBody ? " trace-step-header-toggle" : ""}`}
					onClick={() => hasBody && setIsOpen((p) => !p)}
					disabled={!hasBody}
				>
					{hasBody && (
						<img
							src={chevronUpIcon}
							alt=""
							className={`trace-step-chevron${isOpen ? " trace-step-chevron-open" : ""}`}
						/>
					)}
					{header}
				</button>
				{hasBody && isOpen && (
					<div className="trace-step-accordion-body">{body}</div>
				)}
			</div>
		</div>
	);
};

export default TraceStepItem;
